import { ModuleWithProviders, NgModule } from '@angular/core';
import { GoogleTagManagerService } from './google-tag-manager.service';
import {
  GoogleTagManagerConfiguration,
  GTM_CONFIG,
} from './google-tag.interfaces';

@NgModule({
  providers: [GoogleTagManagerService],
})
export class GoogleTagManagerModule {
  static forRoot(
    config: GoogleTagManagerConfiguration,
  ): ModuleWithProviders<GoogleTagManagerModule> {
    return {
      ngModule: GoogleTagManagerModule,
      providers: [{ provide: GTM_CONFIG, useValue: config }],
    };
  }

  constructor(svc: GoogleTagManagerService) {
    // Kickstart the data layer
    svc.dataLayer$.subscribe();
  }
}
